import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AuthGuard } from './login/services/auth.guard';
import { AppRoutesModule } from './app.routes';
import { LoginService } from './login/services/login.service';
import { HttpModule } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import { DataencryptionService } from './shared/dataencryption.service';
import { ElectionprogramscheduleService } from './shared/electionprogramschedule.service';
import { ReactiveFormsModule } from '@angular/forms';
import { LocalBodyService } from './shared/local-body.service';
import { LocalstorageService } from './shared/localstorage.service';
import { LbToEpDecAuthService } from './shared/AUTHGAURD/lb-to-ep-dec-auth.service';
import { SrExpSubexpAuthService } from './shared/AUTHGAURD/sr-exp-subexp-auth.service';
import { DescDevExpreportAuthService } from './shared/AUTHGAURD/desc-dev-expreport-auth.service';
import { CandidateAuthService } from './shared/AUTHGAURD/candidate-auth.service';
import { RoAuthService } from './shared/AUTHGAURD/ro-auth.service';
import { PartyOfficialAuthService } from './shared/AUTHGAURD/party-official-auth.service';
import { BasicDetailsService } from './shared/basic-details.service';
import { ChartService } from './shared/chart.service';
import { ElectionprogramService } from './user-view/superAdmin/services/electionprogram.service';
import { ChartsModule } from 'ng2-charts';
import * as FusionCharts from 'fusioncharts';
import * as Charts from 'fusioncharts/fusioncharts.charts';
import * as FintTheme from 'fusioncharts/themes/fusioncharts.theme.fint';
import { FusionChartsModule } from 'angular4-fusioncharts';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExcelService } from './user-view/superAdmin/services/excel.service';
import { HttpClientModule } from '@angular/common/http';
import { PollingDataComponent } from './polling-data/polling-data.component';
import { Statement6Component } from './statement6/statement6.component';
import { UploadRepresentativeService } from './shared/upload-representative.service';
import { HashService } from './login/services/hash.service';
import { UtilsService } from './login/services/utils.service';
import { PaymentService } from './login/services/payment.service';


@NgModule({
  declarations: [
    AppComponent,
    PollingDataComponent,
    Statement6Component,
    
       ],
  imports: [
    BrowserModule,
    AppRoutesModule,
    HttpClientModule,
    HttpModule,
    
    ReactiveFormsModule,
    ChartsModule,
    ToastModule.forRoot(),
    BrowserAnimationsModule
    // NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    AuthGuard,
    LoginService,
    CookieService,
    DataencryptionService,
    ElectionprogramscheduleService,
    LocalBodyService,
    LocalstorageService, LbToEpDecAuthService, SrExpSubexpAuthService,
    DescDevExpreportAuthService, CandidateAuthService, RoAuthService, PartyOfficialAuthService,
    BasicDetailsService, ChartService, ElectionprogramService, ExcelService,
    UploadRepresentativeService, HashService, UtilsService, PaymentService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts